import React, { useRef, useState } from "react";
import StepTwoProgress from "../../../../assets/images/brand-steps-progress-indicator/step-two.svg";
import Proptypes from "prop-types";
import styles from "./addbrand.module.scss";
import ImageUploadIcon from "../../../../assets/images/image-upload-icon.svg";
import FileInfoIcon from "../../../../assets/images/file-info-icon.svg";
import CrossIcon from "../../../../assets/images/cross-icon.svg";
import { toast } from "react-toastify";
import Textfield from "../../../Shared/Textfield";
import Button from "../../../Shared/Button";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const StepTwo = ({ setStep, toggle, handleChange, formik, categories }) => {
  const inputRef = useRef();
  const [file, setFile] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [errors, setErrors] = useState({
    primaryProductCategory: "",
    descriptionOrBrand: "",
    file: "",
  });

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (!droppedFile.type.match("image/png|image/jpg")) {
      toast.warning("Only PNG or JPG files are allowed.");
      return;
    }
    setFile(droppedFile);
    handleChange({
      target: { name: "file", value: droppedFile },
    });
  };
  return (
    <>
      <div className={styles["progress_container"]}>
        <div className={styles["progress_container_indicator"]}>
          <img src={StepTwoProgress} width={232} height={42} alt="progress" />
        </div>
      </div>
      <div>
        <p className={styles["heading_container"]}>Add Brand</p>
      </div>
      <div style={{ marginBottom: "19px" }}>
        <p className={styles["description_container"]}>
          Let’s get a little bit of info on the Brand (* indicates that it can
          not be changed later)
        </p>
      </div>

      <div className={styles["inputFieldsDiv"]}>
        <Dropdown
          isOpen={dropdownOpen}
          toggle={() => {
            setDropdownOpen(!dropdownOpen);
          }}
        >
          <DropdownToggle
            className={`${styles["input_field_styles"]} ${styles["brand_dropdown"]}`}
          >
            {formik?.values?.primaryProductCategory ||
              "Primary product category*"}
          </DropdownToggle>
          <DropdownMenu className={styles["menu_dropdown"]}>
            {(categories || [])?.map((brand, index) => {
              return (
                <DropdownItem
                  className={styles["dropdown_item"]}
                  onClick={() => {
                    formik.setFieldValue("primaryProductCategory", brand.name);
                    formik.setFieldValue("categoryId", brand.id);
                  }}
                  key={index}
                >
                  <div>{brand?.name || ""}</div>
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </Dropdown>
        {formik?.errors?.brandId && formik?.touched?.brandId && (
          <div className={styles["error"]}>{formik?.errors?.brandId}</div>
        )}
        {errors?.primaryProductCategory && (
          <div className={styles["error"]}>
            {errors?.primaryProductCategory}
          </div>
        )}
      </div>

      <div
        style={{
          marginBottom: "20px",
        }}
      >
        <Textfield
          value={formik.values.descriptionOrBrand}
          error={errors.descriptionOrBrand}
          touched={errors.descriptionOrBrand}
          handleBlur={formik.handleBlur}
          type="textarea"
          placeholder="Description of brand"
          className={`${styles["input_field_styles"]} ${styles["text_area_styles"]}`}
          onChange={handleChange}
          name="descriptionOrBrand"
          id="descriptionOrBrand"
        />
      </div>
      <p className={styles["input_upload_title"]}>
        Tool Tip: Share relevant documents to help Lumi verify your business:
        Business License, Tax ID, etc
      </p>
      <div
        className={styles["file_upload_container"]}
        onClick={() => inputRef.current.click()}
        role="button"
        tabIndex={0}
        onKeyDown={() => {}}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <div>
          <img src={ImageUploadIcon} alt="img" width={24} height={24} />
        </div>
        <div>
          <p className={styles["upload_text"]}>
            Documents upload (Drag and drop)
          </p>
        </div>
      </div>
      <input
        type="file"
        accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
        ref={inputRef}
        style={{
          display: "none",
        }}
        name="file"
        id="file"
        onChange={(event) => {
          const fileData = event?.target?.files[0];
          const allowedTypes = [
            ".png",
            ".jpg",
            ".jpeg",
            ".pdf",
            ".doc",
            ".docx",
          ];
          const fileType = fileData?.type;
          const fileExtension = fileData?.name.split(".").pop();
          if (!allowedTypes.includes(`.${fileExtension}`)) {
            toast.warning(
              "Only PNG, JPG, JPEG, PDF, DOC, and DOCX files are allowed."
            );
            return;
          } else {
            setFile(fileData);
            handleChange({
              target: { name: "file", value: fileData },
            });
          }
        }}
      />

      {errors?.file && (
        <div className={styles["error"]} style={{ color: "red" }}>
          {errors?.file}
        </div>
      )}

      {file ? (
        <div className={styles["file_info_container"]}>
          <div className={styles["file_name_container"]}>
            <div>
              <img src={FileInfoIcon} alt="img" width={29} height={29} />
            </div>
            <div>
              <p className={styles["file_name_text"]}>{file?.name || ""}</p>
            </div>
          </div>
          <div
            style={{
              cursor: "pointer",
            }}
            role="button"
            onKeyDown={() => {}}
            tabIndex={0}
            onClick={() => {
              setFile(null);
              handleChange({
                target: { name: "file", value: "" },
              });
            }}
          >
            <img src={CrossIcon} alt="cross" width={13} height={13} />
          </div>
        </div>
      ) : null}
      <div
        className={styles["submit_btns"]}
        style={{
          marginTop: "40px",
        }}
      >
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_cancel"]}
            onClick={() => {
              toggle();
            }}
            text="Cancel"
          />
        </div>
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_add"]}
            onClick={() => {
              if (formik.values.primaryProductCategory === "") {
                setErrors({
                  primaryProductCategory: "Required",
                  descriptionOrBrand: "",
                  file: "",
                });
              }
              if (formik.values.descriptionOrBrand === "") {
                setErrors({
                  descriptionOrBrand: "Required",
                  primaryProductCategory: "",
                  file: "",
                });
              }
              if (formik.values.file === "") {
                setErrors({
                  file: "Required",
                  primaryProductCategory: "",
                  descriptionOrBrand: "",
                });
              }

              if (
                formik.values.primaryProductCategory !== "" &&
                formik.values.descriptionOrBrand !== "" &&
                formik.values.file !== ""
              ) {
                setStep(2);
              }
            }}
            text="Next"
          />
        </div>
      </div>
    </>
  );
};
StepTwo.propTypes = {
  setStep: Proptypes.func,
  toggle: Proptypes.func,
  handleChange: Proptypes.func,
  formik: Proptypes.object,
};
export default StepTwo;
